import React from 'react'
import {
  View,
  Icon,
  Screen,
  Text,
  Button,
  ImageBackground,
  Image
} from '@shoutem/ui'

export class WelcomeScreen extends React.PureComponent {
  static navigationOptions = {
    tabBarLabel: 'Home',
    tabBarIcon: ({ tintColor, focused }) => (
      <Icon name="home" size={focused ? 25 : 23} color={tintColor} />
    )
  }
  openSchool = () => this.props.navigation.navigate('ChooseSchool')
  state = { schools: [] }
  render() {
    return (
      <ImageBackground
        styleName="flexible"
        source={{
          uri:
            'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=9731a56510305fd6f05aeaa9d68e41e3&auto=format&fit=crop&w=1050&q=80'
        }}
        style={{
          alignItems: 'center',
          position: 'relative',
          justifyContent: 'center'
          // backgroundColor: '#fff'
        }}
      >
        <View
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            backgroundColor: '#0007'
          }}
        />
        {/* <Screen
        styleName="paper"
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#ffd200'
        }}
      > */}
        {/* <View
          style={{
            // backgroundColor: '#fff',
            alignItems: 'center',
            justifyContent: 'center',
            height: 100,
            width: 100,
            borderRadius: 10
          }}
        >
          <Text
            style={{
              fontFamily: 'Paprika-Regular',
              fontSize: 70,
              color: '#000'
            }}
          >
            A+
          </Text>
        </View> */}
        <View
        // style={{
        //   backgroundColor: '#c887ad',
        //   alignItems: 'center',
        //   justifyContent: 'center',
        //   height: 100,
        //   width: 100,
        //   borderRadius: 10
        // }}
        >
          <Image
            style={{
              height: 150,
              width: 150
            }}
            source={require('../images/logo.png')}
          />
        </View>
        <Text
          style={{
            // fontFamily: 'Paprika-Regular',
            fontSize: 25,
            marginTop: 20,
            // marginBottom: 20,
            maxWidth: 300,
            position: 'relative',
            textAlign: 'center',
            color: '#fff'
          }}
        >
          Welcome to your online GPA assistant
        </Text>
        <Text
          style={{
            // fontFamily: 'Paprika-Regular',
            fontSize: 18,
            marginTop: 20,
            marginBottom: 50,
            fontWeight: 200,
            maxWidth: 300,
            position: 'relative',
            textAlign: 'center',
            color: '#fff'
          }}
        >
          Track your progress with ease
        </Text>
        <Button
          styleName="clear"
          style={{
            height: 50,
            width: 200,
            borderRadius: 5,
            backgroundColor: '#fff'
          }}
          onPress={this.openSchool}
        >
          <Text
            style={{
              // fontFamily: 'Paprika-Regular',
              color: '#000',
              fontSize: 16
            }}
          >
            Get Started
          </Text>
        </Button>
        {/* </Screen> */}
      </ImageBackground>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/WelcomeScreen.js